// External Dependencies
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import MapIcon from '@mui/icons-material/Map';
import Box from '@mui/material/Box';

// Internal Dependencies
import DataGridContainer from 'components/shared/TableDataGrid/DataGridContainer';
import TableDataGrid from 'components/shared/TableDataGrid';
import { EnhancedButton, Subtitle } from 'components/shared';
import { useGetAllOrganizations } from 'hooks/api/organizations';

// Local Dependencies
import { useColumns } from './hooks';

// Component Definition
const Organizations = (): JSX.Element => {
  const navigate = useNavigate();
  const {
    data: organizationsResponse,
    isLoading,
  } = useGetAllOrganizations();

  const columns = useColumns();

  const handleClickRow = useCallback((id: string): string => {
    return `/organizations/${id}`;
  }, [organizationsResponse]);

  const handleClickHeatMap = useCallback(() => {
    navigate('/organizations/heat_map');
  }, [navigate]);

  return (
    <>
      <Box
        alignItems="flex-start"
        display="flex"
        justifyContent="space-between"
      >
        <Subtitle>Organizations</Subtitle>

        <EnhancedButton
          onClick={handleClickHeatMap}
          size="small"
          startIcon={<MapIcon fontSize="small" />}
          variant="outlined"
        >
          Heat Map
        </EnhancedButton>
      </Box>

      <DataGridContainer>
        <TableDataGrid
          clickRowTo={handleClickRow}
          columns={columns}
          loading={isLoading}
          rows={organizationsResponse?.data.data ?? []}
          tableResource="organizations"
          withSearch
        />
      </DataGridContainer>
    </>
  );
};

export default Organizations;
